import { VideoGrid } from '@blocks';

import { useVideoPayload } from './hooks/useVideoPayload';
import * as css from './styles.css';
import { VideoStatus } from './VideoStatus';

export const LiveVideoView = () => {
    const videoPayload = useVideoPayload();
    const isSingleVideo = videoPayload.length === 1;
    return (
        <div className={css.fullscreenLayout({ columns: isSingleVideo ? 'double' : 'triple' })}>
            {videoPayload.map((video) => (
                <VideoGrid
                    key={video?.id}
                    mode="scrub"
                    columns={1}
                    videos={[video]}
                    currentFrame={0}
                    maxFrame={1}
                    playbackSpeed={1}
                />
            ))}
            <VideoStatus />
        </div>
    );
};
